import React from 'react';
import { TrophyIcon } from 'lucide-react';
const stats = [{
  emoji: '📄',
  value: '300+',
  label: 'pages'
}, {
  emoji: '🗂',
  value: '60+',
  label: 'session scripts'
}, {
  emoji: '📝',
  value: '29',
  label: 'professional worksheets'
}, {
  emoji: '🧰',
  value: '20+',
  label: 'named frameworks'
}];
const coverage = ['Onboarding', 'Diagnosis', 'Mindset', 'Action', 'Emotions', 'Communication', 'Closing & Renewal'];
export function ProductReveal() {
  return <section aria-labelledby="reveal-heading" className="w-full bg-white" data-id="element-168" data-mp="28eb3kfvj3cka">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20 text-center" data-id="element-169" data-mp="28c6od1s6ir4p">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-terracotta-soft text-terracotta border border-terracotta/20 text-[11px] sm:text-xs font-bold uppercase tracking-[0.12em]" data-id="element-170" data-mp="2n4qmfo0h28fa">
          <TrophyIcon className="w-4 h-4" aria-hidden="true" data-id="element-171" data-mp="1ul1wilv1z34x" />
          The most complete done-for-you system for life coaches
        </div>

        <h2 id="reveal-heading" className="mt-7 font-serif font-black text-ink text-[30px] sm:text-5xl leading-[1.1] tracking-tight" data-id="element-172" data-mp="1b17bad1chuar">
          The Life Coach&apos;s Complete System™
        </h2>

        <p className="mt-4 font-serif text-lg sm:text-2xl text-sage" data-id="element-173" data-mp="1juamsfsfjx2r">
          6 Tomes + 5 Bonuses — From the first contact to the final graduation
        </p>

        <p className="mt-6 text-ink-soft text-base leading-relaxed max-w-3xl mx-auto" data-id="element-174" data-mp="s238vn4b6ys2">
          More than 300 pages of ready-to-run sessions, worksheets,
          word-for-word scripts, and client follow-up — all done for you, and
          built around{' '}
          <strong className="text-ink font-semibold" data-id="element-175" data-mp="1116twwn1do97">
            The Session-Ready System™
          </strong>
          : every phase of the client journey mapped, scripted, and ready to
          open.
        </p>

        <ul className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-176" data-mp="2ck12uudmh91i">
          {stats.map(stat => <li key={stat.label} className="rounded-2xl bg-cream border border-cream-dark p-4 sm:p-5" data-id="element-177" data-mp="1rsvu6a05qzfw">
              <span className="text-xl" aria-hidden="true" data-id="element-178" data-mp="1msreunazkar9">
                {stat.emoji}
              </span>
              <p className="mt-1 font-serif font-bold text-2xl text-ink" data-id="element-179" data-mp="21pqoshtb8fow">
                {stat.value}
              </p>
              <p className="text-xs sm:text-sm text-ink-muted" data-id="element-180" data-mp="1wpw10n4u0682">{stat.label}</p>
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-181" data-mp="143batq03e063">
          <p className="text-xs uppercase tracking-[0.16em] text-ink-muted font-semibold" data-id="element-182" data-mp="1442wa7zz6hin">
            Full coverage
          </p>
          <ul className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-183" data-mp="1itqw14sid849">
            {coverage.map(chip => <li key={chip} className="rounded-full bg-sage-tint text-sage border border-sage-soft px-3.5 py-1.5 text-xs sm:text-sm font-semibold" data-id="element-184" data-mp="1e068k6ojjwjb">
                {chip}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}